<template>
  <div>
    <div class="container">
      <header>
        <!-- <div>
          <h3 class="company"></h3>
          <div class="icons icons-header">
            <a :href='github_url' target="_blank" class="github-icon"><img src="../assets/images/icon-github.svg" alt="Icon GitHub" /></a>
            <img
              src="../assets/images/icon-frontend-mentor.svg"
              alt="Icon Frontend Mentor"
            />
            <img src="../assets/images/icon-linkedin.svg" alt="Icon LinkedIn" />
            <img src="../assets/images/icon-twitter.svg" alt="Icon Twitter" />
          </div>
        </div> -->
        <div>
          <h3>MinhTechIO</h3>
        </div>
      </header>

      <div class="background">
        <img
          src="../assets/images/pattern-circle.svg"
          alt="Pattern Circle"
          class="pattern-circle"
        />
        <div>
          <img
            src="../assets/images/pattern-rings.svg"
            alt="Pattern Rings"
            class="pattern-rings"
          />
          <img
            src="../assets/images/pattern-rings.svg"
            alt="Pattern Rings"
            class="pattern-rings"
          />
          <img
            src="../assets/images/pattern-rings.svg"
            alt="Pattern Rings"
            class="pattern-rings"
          />
        </div>
      </div>

      <div class="hero">
        <div >
          <!-- <img
            src="../assets/images/pattern-circle.svg"
            alt="Pattern Circle"
            class="pattern-circle-desktop"
          /> -->
        </div>
        <div class="section section-intro hero-text">
          <h1 class="section-header">DOAN QUANG MINH</h1>
          <!-- <h4 class="text-xl">HELLO WORLD</h4>  -->
          <p>
            DevOps Engineer with 4 years of Back-End development knowledge and system-level configuration like infrastructure / networking. 
            3+ years of experiences on application-level from building CICD pipelines with various tools such as Jenkins, Docker, Docker Compose, K8S & monitoring
          </p>
          <p>
            Actively enhancement system-level knowledge on infrastructure, networking / application-level like Kubernetes, Terraform, Ansible & DevSecOps practices, with a long-term focus on MLOps to build scalable, secure, and reliable systems.          </p>
        </div>
      </div>

      <hr />

      <div class="section section-skills">
        <h1 class="section-header">COMPETENCE</h1>
        <div class="stack">
        <div class="stack-title"><h2>PROGRAM LANGUAGE</h2></div>
        <ul>
          <!--PROGRAM LANGUAGE-->
          <li>
            <h3>Java</h3>
          </li>
          <li>
            <h3>JavaScript</h3>
          </li>
          <li>
            <h3>Python</h3>
          </li>
          <li>
            <h3>Bash</h3>
          </li>
        </ul>
        </div>
        <hr />
        <div class="stack">
          <div class="stack-title"><h2>BACKEND FRAMEWORK</h2></div>
          <ul>
            <!--BACK END FRAMEWORK-->
            <li>
              <h3>NodeJS</h3>
            </li>
            <li>
              <h3>Spring Boot</h3>
            </li>
          </ul>
        </div>
        <hr />
        <div class="stack">
          <div class="stack-title"><h2>DB</h2></div>
          <ul>
            <!--DB-->
            <li>
              <h3>MySQL</h3>
            </li>
            <li>
              <h3>MongoDB</h3>
            </li>
          </ul>
        </div>
        <hr />
        <div class="stack">
          <div class="stack-title"><h2>DEVOPS TOOLING</h2></div>
          <ul>
            <!--Forge Software-->
            <li>
              <h3>Docker</h3>
            </li>
            <li>
              <h3>Docker Compose</h3>
            </li>
            <li>
              <h3>Jenkins</h3>
            </li>
            <li>
              <h3>Kubernetes</h3>
            </li>
            <li>
              <h3>Git</h3>
            </li>
            <li>
              <h3>Maven</h3>
            </li>
            <li>
              <h3>NPM</h3>
            </li>
          </ul>
        </div>
        <hr />
        <div class="stack">
          <div class="stack-title"><h2>SERVER</h2></div>
          <ul>
            <!--Servers-->
            <li>
              <h3>Nginx</h3>
            </li>
            <li>
              <h3>JBOSS</h3>
            </li>
            <li>
              <h3>Tomcat</h3>
            </li>
          </ul>
        </div>
        <hr />
        <div class="stack">
          <div class="stack-title"><h2>PLATFORM</h2></div>
          <ul>
            <!--CS FUNDAMENTAL-->
            <li>
              <h3>Linux Server</h3>
            </li>
            <li>
              <h3>Network Fundamental</h3>
            </li>
          </ul>
        </div>
        <hr />
        <div class="stack">
          <div class="stack-title"><h2>PROTOCOL</h2></div>
          <ul>
            <!--Protocols-->
            <li>
              <h3>HTTP</h3>
            </li>
            <li>
              <h3>WebSocket</h3>
            </li>
            <li>
              <h3>SSH</h3>
            </li>
          </ul>
        </div>
        <hr />
        <div class="stack">
          <div class="stack-title"><h2>CLOUD & SERVICE</h2></div>
          <ul>
            <!--Protocols-->
            <li>
              <h3>Firebase</h3>
            </li>
            <li>
              <h3>Cloudflare</h3>
            </li>
            <li>
              <h3>AWS</h3>
            </li>
          </ul>
        </div>
        <hr />
      </div>
      
      <hr class="hr-projects" />

      <div class="section section-project">
        <div class="projects">
          <div class="inline">
            <h1 class="section-header">PROJECT</h1>
          </div>
          <ul>
            <li>
              <div class="thumbnail-project" id="tp1" />
              <div class="overlay">
                <div class="learn-more-overlay">
                  <a :href='project_urls[0]' target="_blank"><button>View</button></a>
                </div>
              </div>
              <h3>Piggy Metric</h3>
              <ul>
                <li>Java</li>
                <li>Spring Boot</li>
              </ul>
            </li>
            <li>
              <div class="thumbnail-project" id="tp2" />
              <div class="overlay">
                <div class="learn-more-overlay">
                  <a :href='project_urls[1]' target="_blank"><button>View</button></a>
                </div>
              </div>
              <h3>Piggy Metric CICD</h3>
              <ul>
                <li>Docker</li>
                <li>Docker Compose</li>
                <li>Jenkins</li>
                <li>K3S</li>
                <li>K3S</li>
                <li>Bash</li>
                <li>Linux Server</li>
                <li>Prometheus</li>
                <li>Grafana</li>
              </ul>
            </li>
            <li>
              <div class="thumbnail-project" id="tp3" />
              <div class="overlay">
                <div class="learn-more-overlay">
                  <a :href='project_urls[2]' target="_blank"><button>View</button></a>
                </div>
              </div>
              <h3>Live Camera Py</h3>
              <ul>
                <li>Python</li>
                <li>Raspeberry PI</li>
                <li>Cloudflare</li>
                <li>Docker</li>
                <li>Bash</li>
                <li>Linux Server</li>
              </ul>
            </li>
            <li>
              <div class="thumbnail-project" id="tp4" />
              <div class="overlay">
                <div class="learn-more-overlay">
                  <a :href='project_urls[3]' target="_blank"><button>View</button></a>
                </div>
              </div>
              <h3>Drone Delivery</h3>
              <ul>
                <li>Java</li>
                <li>J2E</li>
                <li>.NET</li>
                <li>MySQL</li>
              </ul>
            </li>
            <li>
              <div class="thumbnail-project" id="tp5" />
              <div class="overlay">
                <div class="learn-more-overlay">
                  <a :href='project_urls[4]' target="_blank"><button>View</button></a>
                </div>
              </div>
              <h3>Drone Delivery CICD</h3>
              <ul>
                <li>Docker</li>
                <li>Docker Compose</li>
                <li>Jenkins</li>
                <li>Bash</li>
                <li>Linux Server</li>
              </ul>
            </li>
            <li>
              <div class="thumbnail-project" id="tp6" />
              <div class="overlay">
                <div class="learn-more-overlay">
                  <a :href='project_urls[5]' target="_blank"><button>View</button></a>
                </div>
              </div>
              <h3>K8S Explorement</h3>
              <ul>
                <li>K3S</li>
                <li>Rancher</li>
                <li>Terraform</li>
                <li>Bash</li>
                <li>Linux Server</li>
              </ul>
            </li>
            <li>
              <div class="thumbnail-project" id="tp7" />
              <div class="overlay">
                <div class="learn-more-overlay">
                  <a :href='project_urls[6]' target="_blank"><button>View</button></a>
                </div>
              </div>
              <h3>AWS Three Tier Web</h3>
              <ul>
                <li>AWS</li>
                <li>Localstack</li>
                <li>Docker</li>
                <li>Terraform</li>
                <li>Bash</li>
                <li>Linux Server</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="section section-contact">
      <div class="contact" ref="targetContact">
        <div class="contact-text">
          <div>
            <h1 class="section-header">CONTACT</h1>
            <p>
              I would love to hear about your project and how I could help. Please
              fill in the form, and I'll get back to you as soon as possible.
            </p>
          </div>
          <ContactForm />
        </div>
        <hr class="hr-bottom" />
      </div>
    </div>
    <footer>
      <div>
        <h3>MinhTechIO</h3>
        <div class="icons">
          <a :href='github_url' target="_blank" class="github-icon"><img src="../assets/images/icon-github.svg" alt="Icon GitHub" /></a>
          <!--
          <img
            src="../assets/images/icon-frontend-mentor.svg"
            alt="Icon Frontend Mentor"
          />
          <img src="../assets/images/icon-linkedin.svg" alt="Icon LinkedIn" />
          <img src="../assets/images/icon-twitter.svg" alt="Icon Twitter" />
          -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import ContactForm from "./ContactForm.vue";
import { animate, stagger, text } from 'animejs';
export default {
  name: "DeveloperPortfolio",
  components: {
    ContactForm,
  },
  data() {
    return {
      msg: [],
      validEmail: {},
      github_url: "https://github.com/dqminh2810",
      project_urls : [
        "https://github.com/dqminh2810/PiggyMetric",
        "https://github.com/dqminh2810/PiggyMetricCICD",
        "https://github.com/dqminh2810/live-camera-py",
        "https://github.com/dqminh2810/drone-delivery-isa-devops",
        "https://github.com/dqminh2810/drone-delivery-isa-devops/tree/master/docker",
        "https://github.com/dqminh2810/explorement-k3s",
        "https://github.com/dqminh2810/aws-three-tier-web"
      ],
    };
  },
  mounted() {
    let { chars } = text.split('h3', { chars: true, });
    animate(chars, {
      // Property keyframes
      y: [
        { to: '-2.75rem', ease: 'outExpo', duration: 600 },
        { to: 0, ease: 'outBounce', duration: 800, delay: 100 }
      ],
      // Property specific parameters
      rotate: {
        from: '-1turn',
        delay: 0
      },
      delay: stagger(100),
      ease: 'inOutCirc',
      loopDelay: 1000,
      loop: true
    });
  },
  created() {
    if (window.addEventListener) {
      addEventListener("DOMContentLoaded", this.checkForVisibility, false);
      addEventListener("load", this.checkForVisibility, false);
      addEventListener("scroll", this.checkForVisibility, false);
    }
  },
  methods: {
    validateAll() {
      this.validateEmail();
      return;
    },
    validateEmail() {
      /* eslint-disable */
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        this.validEmail = true;
      } else {
        this.validEmail = false;
      }
    },
    scrollToContact() {
          const targetElement = this.$refs.targetContact;
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' }); // 'smooth' for animated scrolling
          }
    },
    isElementInViewport(el) {
      var rect = el.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    checkForVisibility() {
      let headers = document.querySelectorAll(".section-header");
      headers.forEach((header) => {
      if (this.isElementInViewport(header)) {
        header.classList.add("section-header-visible");
      } else {
        header.classList.remove("section-header-visible");
      }});
    }
    
  }
};
</script>

<style scoped>
.pattern-circle {
  position: absolute;
  top: 254px;
  right: -60px;
}

.pattern-circle-desktop {
  display: none;
}
.pattern-rings {
  position: absolute;
  width: 530px;
  height: 129px;
}
.pattern-rings:nth-child(1) {
  top: 124px;
  left: -350px;
}
.pattern-rings:nth-child(2) {
  top: 1515px;
  right: -350px;
}
.pattern-rings:nth-child(3) {
  bottom: 140px;
  left: -350px;
}

header {
  position: absolute;
  width: 100vw;
  display: flex;
  justify-content: center;
}

header > div {
  width: 154px;
  height: 72px;
}
.company {
  height: 32px;
}
.icons {
  height: 20px;
  display: flex;
  justify-content: space-between;
}
.github-icon {
  margin-left: auto; 
  margin-right: 0;
}
.image-profile {
  width: 174px;
  height: 383px;
  background-image: url("../assets/images/image-profile-mobile.webp");
  background-size: cover;
  background-repeat: no-repeat;
  margin: auto;
}
hr {
  margin: 80px 16px;
}
ul {
  padding: 0px;
  list-style-type: none;
}
.projects {
  text-align: start;
  margin: 0px 16px;
}
.inline {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.learn-more {
  display: flex;
  margin-top: 20px;
  margin-bottom: 40px;
}
.learn-more > button {
  margin-right: 30px;
}

.projects > ul > li > ul {
  display: flex;
  margin-bottom: 16px;
}
.projects > ul > li > ul > li {
  margin-right: 16px;
}
.thumbnail-project {
  width: 100%;
  height: 253px;
  background-size: cover;
  background-repeat: no-repeat;
}
#tp1 {
  background-image: url("../assets/images/thumbnail-project-1-small.webp");
}
#tp2 {
  background-image: url("../assets/images/thumbnail-project-2-small.webp");
}
#tp3 {
  background-image: url("../assets/images/thumbnail-project-3-small.webp");
}
#tp4 {
  background-image: url("../assets/images/thumbnail-project-4-small.webp");
}
#tp5 {
  background-image: url("../assets/images/thumbnail-project-5-small.webp");
}
#tp6 {
  background-image: url("../assets/images/thumbnail-project-6-small.webp");
}
#tp7 {
  background-image: url("../assets/images/thumbnail-project-7-small.webp");
}
.contact {
  background-color: #242424;
  padding: 60px 16px;
}
footer {
  background-color: #242424;
  width: 100%;
  margin-top: -100px;
  height: 160px;
  display: flex;
  justify-content: center;
}
.section-header {
  opacity: 0;
  transform: translateY(50px);
  transition: all 1.2s ease-out;
}

.section-header-visible {
  opacity: 1;
  transform: translateY(0);
}
@media screen and (min-width: 300px) {
  header {
    position: relative;
    width: 100vw;
    display: flex;
    justify-content: center;
  }
  .icons {
    height: 20px;
    margin-bottom: 50px;
    display: block;
  }
  .icons-header {
    display: none;
  }
}
@media screen and (min-width: 700px) {
  .container {
    margin: 30px;
  }
  header {
    width: calc(100vw - 60px);
    max-width: 1110px;
    z-index: 1;
  }
  header > div {
    width: 100%;
    max-width: 1110px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .company {
    margin: 0;
  }
  .icons {
    height: 25px;
    width: 200px;
    display: flex;
    justify-content: space-between;
  }
  .image-profile {
    width: 322px;
    height: 600px;
    background-image: url("../assets/images/image-profile-tablet.webp");
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
  }
  .hero {
    width: 75%;
    padding-top: 150px;
  }
  .hero-text {
    position: relative;
  }
  .pattern-circle {
    z-index: 1;
    top: 470px;
  }
  .stack > ul {
    display: flex;
    flex-wrap: wrap;
  }
  .stack > ul > li {
    width: 50%;
  }
  .hr-projects {
    display: none;
  }
  .projects > ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .projects > ul > li {
    width: 342px;
  }
  .contact {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .contact-text {
    max-width: 445px;
  }
  footer {
    padding: 100px 30px 0px 30px;
    width: calc(100vw - 60px);
  }
  footer > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .hr-bottom {
    position: absolute;
    width: calc(100vw - 60px);
    left: 15px;
    bottom: 50px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    width: 1110px;
    margin-left: auto;
    margin-right: auto;
  }
  .header > div {
    margin: 0;
    max-width: 1110px;
  }
  .hero {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    padding-top: 0;
    margin-top: -30px;
  }
  .image-profile {
    width: 445px;
    height: 720px;
    background-image: url("../assets/images/image-profile-desktop.webp");
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    margin: 0;
  }
  .hero-text {
    width: 800px;
    margin-top: 130px;
  }
  .hero-text > h1 {
    width: 800px;
  }
  .pattern-circle {
    display: none;
  }
  .pattern-circle-desktop {
    display: block;
    margin-top: 530px;
    margin-left: -60px;
  }
  .pattern-rings:nth-child(1) {
    top: 124px;
    left: -150px;
  }
  .icons {
    margin-right: 30px;
  }
  .projects > ul > li {
    width: 530px;
    margin-bottom: 60px;
  }
  .thumbnail-project {
    height: 400px;
  }
  .learn-more {
    display: none;
  }
  .overlay {
    position: absolute;
    margin-top: -400px;
    width: 530px;
    height: 400px;
    background-color: #000000;
    opacity: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .learn-more-overlay {
    display: block;
    text-align: center;
  }
  .learn-more-overlay > button {
    margin: 20px;
  }
  .overlay:hover {
    opacity: 0.75;
  }
  .contact-text {
    text-align: left;
    width: 1110px;
    max-width: 1110px;
    display: flex;
    justify-content: space-between;
  }
  .contact-text > div {
    width: 445px;
  }

  .hr-bottom {
    width: 1110px;
    left: auto;
  }
  footer > div {
    margin: 0;
    width: 1110px;
  }
}
</style>
